import { useCallback, useContext } from "react";

import { ClickTrackerService } from "@app/util/clickTracker/ClickTrackerService";

import ClickTrackerContext from "./ClickTrackerContext";

interface ClickTrackerArguments {
  disabled?: boolean;
  onClick?: () => void;
  trackKey?: string;
}

const useClickTracker = ({ disabled, onClick, trackKey }: ClickTrackerArguments): (() => void) => {
  const clickTracker = useContext<ClickTrackerService>(ClickTrackerContext);

  return useCallback(() => {
    if (disabled) {
      return;
    }

    onClick?.();

    if (trackKey) {
      clickTracker.click(trackKey);
    }
  }, [clickTracker, disabled, onClick, trackKey]);
};

export default useClickTracker;
